import React from 'react'
import PropTypes from 'prop-types'

import Label from '../../label'
import List from '../../list/list'
import Empty from '../../empty'
import Button from '../../button/button'
import ButtonAsync from '../../button/button-async'
import SidePanel from '../../panels/sidePanel/sidePanel'
import SidePanelContainer from '../../panels/sidePanel/sidePanel-transition'


//http://stackoverflow.com/questions/28750489/upload-file-component-with-reactjs
//http://codepen.io/hartzis/pen/VvNGZP
//http://www.hartzis.me/react-image-upload/

import './upload.styl'
class FilesUpload extends React.Component {

    static PANEL_ID = 0;

    constructor(props) {
        super(props);
        this.pathI18n = 'app.components.filesUpload.'
        this.state = {
            files:[],
            uploaded:[],
            dragActive: false
        }
        this.sidePanelContainerId = 'sidePanel-filesUpload-' + FilesUpload.PANEL_ID++;
        this.onDragOver = this.onDragOver.bind(this)
        this.onDragLeave = this.onDragLeave.bind(this)
        this.onDrop = this.onDrop.bind(this)
        this.onClick = this.onClick.bind(this)
        this.send = this.send.bind(this)
        this.remove = this.remove.bind(this)
    }

    remove(file, e) {
        e.preventDefault();
        e.stopPropagation();
        let idx = this.state.files.findIndex( e => {
            console.log(e);
            return e.name === file.name
        });
        this.state.files.splice(idx, 1);
        this.setState(this.state);
    }

    onDragLeave(e) {
        this.setState({
            dragActive: false
        });
    }

    onDragOver(e) {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'copy';

        this.setState({
            dragActive: true
        });
    }

    onDrop(e) {
        e.preventDefault();
        this.setState({ dragActive: false });
        let files = e.target.files || (e.dataTransfer && e.dataTransfer.files);
        files =  Object.keys(files).map( key => files[key]);
        files.forEach( (file, index) => {
            let reader = new FileReader();
            reader.onloadend = e => {
                file.content = e.target.result;
                this.state.files.push(file);
                this.setState(this.state);
                this.props.onDrop && this.props.onDrop(file);
            }
            reader.readAsDataURL(file);
        });
    }

    send () {
        this.state.files.forEach(file => {
            let uploaded = () => {
                let idx = this.state.files.findIndex( e => e.name === file.name)
                this.state.files.splice(idx, 1);
                file.db = file.content;
                this.state.uploaded.push(file)
                this.setState(this.state);
            }
            let rslt = this.props.upload(file)
            console.log(rslt, rslt && rslt.then, rslt && (rslt.then instanceof Function));
            rslt && (rslt.then instanceof Function) ? rslt.then(uploaded, err => console.log(err)) : uploaded();
        });
    }

    onClick() {
        this.fileInput.click();
    }

    view(file) {
        return <div className="table-list-column">
            <img src={file.content} />
            <Button onClick={ e => this.remove(file, e) } label='app.remove' />
        </div>
    }

    render() {
        let {pathI18n} = this
        let { label } = this.props;
        let { uploaded=[] } = this.state
        let dragging = this.state.dragActive ? ' dragging' : ''
        let fileList = {type: List, attrs:{collection: uploaded.map(file => <div className="table-list-column">{file.name}</div>)} }

        return (<div className="form form-upload">
            <Label>{label}</Label>:

            <div className='form-upload-dragzone'>
                <div className={'form-upload-files' + dragging} onClick={this.onClick} onDragLeave={this.onDragLeave} onDragOver={this.onDragOver} onDrop={this.onDrop}>
                    <Label>{label + '.dropzone'}</Label>
                    <input type = {'file'} ref={node => this.fileInput = node} style={{display: 'none' }} multiple  onChange = {this.onDrop} />
                    <List printable={this.state.files} collection={this.state.files.map(file => this.view(file))} />
                </div>

                <div className="form-upload-sidePanel">
                    <SidePanelContainer id={ this.sidePanelContainerId }/>
                </div>
            </div>

            <button type="button" onClick={this.send.bind(this)}><Label>{label + '.send'}</Label></button>

            {fileList.length && <SidePanel openerType={ButtonAsync}
                       openerAttrs={{onClick: e => Promise.resolve(fileList), label:pathI18n + 'sidepanel.open.async', disabled: !uploaded.length}}
                       containerId={ this.sidePanelContainerId }/>}
        </div>)
    }
}

FilesUpload.propTypes = {
    label: PropTypes.string,
    upload: PropTypes.func.isRequired,
    onDrop: PropTypes.func
}

FilesUpload.defaultProp = {
    disabled: false
}

export default FilesUpload
